import { render, staticRenderFns } from "./givingFamily.vue?vue&type=template&id=8aadc3c4&"
import script from "./givingFamily.vue?vue&type=script&lang=js&"
export * from "./givingFamily.vue?vue&type=script&lang=js&"
import style0 from "./givingFamily.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports